import { render } from "./ClientsHeader.vue?vue&type=template&id=ec629af6"
import script from "./ClientsHeader.vue?vue&type=script&lang=js"
export * from "./ClientsHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__